import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import TableDocument from "../../TableDocument";
import FilterModal from "../../../../Components/Common/FilterModal";
import { get } from "../../../../utils/api";
import {
  displayDocumentationCell,
  formatReportingPeriod,
} from "../../../../utils/documentationTableHelpers";

const API_BASE = "/scope3/franchises";

/** Documents API nests master under `fm`; list view may use populated `franchiseMaster`. */
const mapFranchiseDocumentRow = (item) => {
  const m =
    item?.fm ||
    (item?.franchiseMaster && typeof item.franchiseMaster === "object"
      ? item.franchiseMaster
      : null) ||
    {};
  return {
    ...item,
    franchiseName: displayDocumentationCell(
      m?.franchiseName ?? item?.franchiseName
    ),
    country: displayDocumentationCell(m?.country ?? item?.country),
    franchiseType: displayDocumentationCell(
      m?.franchiseType ?? item?.franchiseType
    ),
    reportingPeriod: displayDocumentationCell(formatReportingPeriod(item)),
  };
};

const FranchisesDocuments = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const columnWidth = "12% 22% 16% 20% 20% 10%";

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [filter, setFilter] = useState({
    country: [],
    franchiseType: [],
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, nextUrl) => {
    setSelectedOption(option);
    setUrl(nextUrl);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        facilityList: selectedFacility.join(","),
        limit: 10,
        search: searchQuery,
      }).toString();

      const response = await get(
        `${API_BASE}/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      const rows = response.data.data || [];
      setData(rows.map(mapFranchiseDocumentRow));
      setTotalPages(response.data.totalPages);
      setPage(response.data.currentPage);
    } catch (error) {
      console.error("Error fetching franchises documents:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility, searchQuery]);

  // const fetchFilter = async () => {
  //   try {
  //     const response = await get(`${API_BASE}/filter`);
  //     const { country, franchiseType } = response.data?.data || {};
  //     setFilter({
  //       country: country || [],
  //       franchiseType: franchiseType || [],
  //     });
  //   } catch (error) {
  //     console.error("Error fetching franchises document filters:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchFilter();
  // }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const heading = [
    { title: "Date", key: "createdAt" },
    { title: "Franchise Name", key: "franchiseName" },
    { title: "Country", key: "country" },
    { title: "Franchise Type", key: "franchiseType" },
    { title: "Reporting Period", key: "reportingPeriod" },
  ];

  const filterData = [
    { title: "Date", type: "date", key: "date", value: [] },
    {
      title: "Reporting Period",
      type: "reportingYearRange",
      key: "reportingPeriod",
      value: [],
    },
    {
      title: "Country",
      type: "option",
      key: "country",
      value: filter.country || [],
    },
    {
      title: "Franchise Type",
      type: "option",
      key: "franchiseType",
      value: filter.franchiseType || [],
    },
  ];

  const toggleData = [];

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
          searchQuery,
          setSearchQuery,
          fetchData,
        }}
        heading="Franchises"
      />

      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={heading}
        columnWidth={columnWidth}
      />

      {/* <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      /> */}
    </MainDashboardLayout>
  );
};

export default FranchisesDocuments;
